/* ==========================================================================
   <flux-video-speler> — zwevende video op de homepage.

   data-staat stuurt welk icoon zichtbaar is (zie de sectie):
     pauze   speelt niet            → afspeelicoon
     stil    speelt zonder geluid   → geluid-uit-icoon
     geluid  speelt met geluid      → icoon verborgen tot hover

   Minimaliseren (streepje) toont een witte kaart met de video als thumbnail
   (speelt zonder geluid door) en een afspeelknop; een klik daarop klapt hem
   weer uit.
   Standaard uitgeklapt, ook op mobiel.
   Kiest de bezoeker zelf, dan geldt die keuze de rest van het bezoek
   (sessionStorage: 'mini' of 'open'). Niet in de editor.
   ========================================================================== */

(() => {
  const SLEUTEL = 'flux-video-speler-mini';

  class FluxVideoSpeler extends HTMLElement {
    connectedCallback() {
      this.editor = Boolean(window.Shopify && window.Shopify.designMode);
      this.video = this.querySelector('video');
      this.knop = this.querySelector('[data-video-geluid]');
      this.volledig = this.querySelector('[data-video-volledig]');
      this.mini = this.querySelector('[data-video-openen]');

      this.querySelector('[data-video-minimaliseren]')?.addEventListener('click', () => this.#minimaliseer());
      this.mini?.addEventListener('click', () => this.#open());
      this.knop?.addEventListener('click', () => this.#wissel());

      const keuze = this.editor ? null : this.#bewaard();
      if (keuze === 'mini') this.#toon(true);
      this.#speelStil();
    }

    #wissel() {
      const v = this.video;
      if (v.paused) {
        v.muted = false;
        v.play().finally(() => this.#zet());
      } else {
        v.muted = !v.muted;
        this.#zet();
      }
    }

    #zet() {
      const v = this.video;
      const staat = v.paused ? 'pauze' : v.muted ? 'stil' : 'geluid';
      this.dataset.staat = staat;
      this.knop?.setAttribute('aria-pressed', String(staat === 'geluid'));
    }

    #toon(mini) {
      if (this.volledig) this.volledig.hidden = mini;
      if (this.mini) this.mini.hidden = !mini;
      // De video zelf dient als thumbnail: verplaatsen in plaats van een
      // tweede video laden. Terug op zijn plek (vóór de geluidsknop) bij openen.
      const thumb = this.querySelector('[data-video-thumb]');
      if (!this.video || !thumb) return;
      if (mini) thumb.append(this.video);
      else this.knop?.before(this.video);
    }

    #speelStil() {
      if (!this.video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.video.muted = true;
      this.video.play().then(() => this.#zet()).catch(() => this.#zet());
    }

    #minimaliseer() {
      this.#toon(true);
      this.#speelStil();
      this.mini?.focus();
      this.#bewaar(true);
    }

    #open() {
      this.#toon(false);
      this.#bewaar(false);
      this.#speelStil();
      this.querySelector('[data-video-minimaliseren]')?.focus();
    }

    #bewaar(mini) {
      if (this.editor) return;
      try {
        sessionStorage.setItem(SLEUTEL, mini ? 'mini' : 'open');
      } catch {}
    }

    #bewaard() {
      try {
        return sessionStorage.getItem(SLEUTEL);
      } catch {
        return null;
      }
    }
  }

  if (!customElements.get('flux-video-speler')) customElements.define('flux-video-speler', FluxVideoSpeler);
})();
